import React, { Component } from "react";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2
} from "react-html-parser";

import Notificacao from "../../components/Notificacao";

import moment from "moment";

import {
  firebaseAuth,
  firebaseFire as Libfirebase,
  firebaseStorage
} from "../../helpers/firebase-config";
import Comentario from "../Comentario";
import ListStatus from "../ListStatus";
import ModalComponent from "../Modal";

export default class Exame extends Component {
  state = {
    comentario: "",
    ref: null,
    alertMsg: null,
    status: null,
    openModal: false
  };

  componentDidMount() {
    const { idPaciente, id } = this.props.item;
    let refPaciente = Libfirebase.collection("paciente").doc(idPaciente);

    var that = this;
    let ref = Libfirebase.collection("paciente")
      .doc(idPaciente)
      .collection("exames")
      .doc(id)
      .collection("Comentarios");

    var unsubscribe = ref.orderBy("data", "desc").onSnapshot(snap => {
      let listComentario = [];

      snap.forEach(doc => {
        doc
          .data()
          .refProfissional.get()
          .then(prof => {
            const data = {
              id: doc.id,
              comentario: doc.data(),
              profissional: prof.data(),
              idProfissional: prof.id
            };

            listComentario.push(data);

            that.setState({ listComentario });
          });
      });
    });

    that.setState({ ref, unsubscribe, refPaciente });
  }

  _setComentario = () => {
    const { comentario, ref } = this.state;
    const { profissional } = this.props.item;
    this.setState({ notifition: false });
    var that = this;
    const refProfissional = Libfirebase.collection("usuario").doc(
      profissional.CPF
    );
    if (comentario) {
      ref
        .add({
          comentario,
          refProfissional,
          dataHoraCriacao: moment().format("DDMMYYYYHHmmss"),
          data: moment().format("YYYY-MM-DD HH:mm:ss")
        })
        .then(() => {
          that.setState({
            openModal: true,
            comentario: "",
            notifition: true,
            msg: "Comentário inserido com sucesso!",
            nameclass: "alert-success"
          });
        })
        .catch(error => {
          that.setState({
            notifition: true,
            msg: error.code,
            nameclass: "alert-danger"
          });
        });
    } else {
      that.setState({
        openModal: false,
        notifition: true,
        msg: "Favor preencher o comentário!",
        nameclass: "alert-warning"
      });
    }
  };

  componentWillUnmount() {
    const { unsubscribe } = this.state;

    unsubscribe();
  }

  _setStatus = value => {
    const { idPaciente, id } = this.props.item;
    const { refPaciente } = this.state;
    this.setState({ status: value, notifition: false, msg: "", nameclass: "" });
    this.props.item.exame.status = value;
    var that = this;
    refPaciente
      .update({ status: value })
      .then(() => {
        Libfirebase.collection("paciente")
          .doc(idPaciente)
          .collection("exames")
          .doc(id)
          .update({ status: value })
          .then(() => {
            that.setState({
              openModal: false,
              notifition: true,
              msg: "Status alterado com sucesso!",
              nameclass: "alert-success"
            });
          })
          .catch(error => {
            that.setState({
              openModal: false,
              status: null,
              notifition: true,
              msg: "Houve um erro ao salvar o status",
              nameclass: "alert-danger"
            });
          });
      })
      .catch(error => {
        that.setState({
          openModal: false,
          status: null,
          notifition: true,
          msg: "Houve um erro ao salvar o status",
          nameclass: "alert-danger"
        });
      });
  };
  render() {
    return (
      <div
        className="container"
        style={{ overflowY: "scroll", overflowX: "hidden", maxHeight: "80vh" }}
      >
        <div className="row">
          <label>Exame: </label> {this.props.item.exame.exame}
        </div>

        <div className="row">
          <label> Data: </label>{" "}
          {this.props.item.exame.dataSolicitacao
            ? moment(this.props.item.exame.dataSolicitacao).format("DD/MM/YYYY")
            : ""}
        </div>

        <div className="row">
          <label> Observação: </label>{" "}
          {ReactHtmlParser(this.props.item.exame.Observacao)}
        </div>
        <br />

        <div className="row">
          <label> Anexos:</label>

          {this.props.item.listMidia ? (
            <div className="row">
              {this.props.item.listMidia.map(midia => {
                return (
                  <div className="col-md-4" key={midia.id}>
                    <img src={midia.midia.url} className="img-fluid" />
                  </div>
                );
              })}
            </div>
          ) : (
            "Sem anexos!"
          )}
        </div>
        <br />

        <div className="row">
          <div className="col-s12">
            <ListStatus
              change={event => this._setStatus(event.target.value)}
              status={this.props.item.exame.status}
            />
          </div>
        </div>
        {this.state.notifition ? (
          <Notificacao msg={this.state.msg} nameclass={this.state.nameclass} />
        ) : null}

        <Comentario
          // teste={"Chápeu"}
          comentario={this.state.listComentario}
          usuario={this.props.usuario}
          _setComentario={this._setComentario}
          _setStateComentario={comentario => {
            this.setState({ comentario });
          }}
          Txtcomentario={this.state.comentario}
        />

        <ModalComponent
          openModal={this.state.openModal}
          closeModal={() => this.setState({ openModal: false })}
        >
          <h2>Deseja atualizar o status do histórico?</h2>
          <p>
            Apenas alterando o status que os outros profissionais saberão do seu
            comentário!
          </p>
          <ListStatus
            status={this.state.status}
            change={event => this.setState({ status: event.target.value })}
          />
          <div style={{ float: "right" }}>
            <button
              style={{ float: "left" }}
              onClick={() => this._setStatus(this.state.status)}
              type="button"
              className="btn waves-effect waves-light btn-success"
            >
              Alterar Status
            </button>
            <button
              style={{ float: "left" }}
              onClick={() => this.setState({ openModal: false })}
              type="button"
              className="btn waves-effect waves-light btn-danger"
            >
              Cancelar
            </button>
          </div>
        </ModalComponent>
      </div>
    );
  }
}
